//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

export const VALIDATION_STEP_LABELS = {
  ONE: 'Verifying file format...',
  TWO: 'Processing File...',
  THREE: 'Catalog Validated',
};

export const STATUS_INTERVAL = 1000;

// max time in seconds of 2 minutes
export const MAX_TIME = 120;
export const ONE_MINUTE = 60;
